import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool
};

export default function FormField(props) {
  const {
    label,
    name,
    type = 'text',
    value,
    onChange,
    error,
    placeholder,
    required
  } = props;

  const id = `interest-${name}`;

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-semibold text-cs-gray-900">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-error` : undefined}
        className={classNames(
          `w-full bg-white border rounded-cs-6 px-4 py-3
           text-base text-cs-gray-900 placeholder:text-cs-gray-400
           focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-1`,
          error ? 'border-red-500' : 'border-cs-gray-300'
        )}
      />
      {error && (
        <p id={`${id}-error`} className="text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}
